import { Injectable } from '@angular/core';

import { ApiService } from '../../backend/api.service';
import { DataResponse } from '../../model/api/DataResponse';
import { EsignatureModule } from '../esignature.module';

@Injectable({
  providedIn: EsignatureModule
})
export class EsignatureService {

  constructor(
    private apiService: ApiService,
  ) { }

  public async hasValidsignature(pid: string): Promise<boolean> {
    const checkResponse = await this.apiService.get<DataResponse<boolean>>('e-signature/validate-user-esignature-by-pid/' + pid).toPromise();
    return checkResponse.data;
  }
}